import { useEffect, useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const QuillTranslationTextarea = ({ initContent, setInputData, id }) => {
    const [quillContent, setQuillContent] = useState('');
    useEffect(() => {
        setInputData(prevState => ({
            ...prevState,
            description: {
                ...prevState.description,
                [id]: quillContent
            }
        }));
    }, [quillContent])

    const [isFirstDone, setIsForstDone] = useState(false);
    useEffect(() => {
        if (initContent && !isFirstDone) {
            setQuillContent(initContent);
            setIsForstDone(true);
        }
    }, [initContent])
    return (
        <ReactQuill value={quillContent} onChange={setQuillContent} />
    )
}

export default QuillTranslationTextarea;